import { BuildType, ModelType } from '@biteinc/enums';

import { TimeHelper } from '../helpers/time_helper';

app.Build = app.AbstractModel.extend({
  ModelName: 'build',
  Schema: {
    displayName: 'build',
  },
  Type: ModelType.Build,

  displayName() {
    if ([BuildType.CustomCssGcn, BuildType.CustomCssVitrine].includes(this.get('type'))) {
      const [orgName, filename, checksum] = this.get('name').split('|');
      const createdAtStr = TimeHelper.format(this.get('createdAt'), 'YYYY-MM-DD HH:mm');

      return `${orgName}/${filename} ${createdAtStr} (${checksum.substring(0, 6)})`;
    }
    return this.get('name');
  },
});
